import React from 'react';

import { FieldPropType } from '../../../../utility/prop_types/CriteriaPropTypes';
import { Field } from './Interfaces/Filter';
import InputLabel from '../InputLabel';

const propTypes = {
    field: FieldPropType.isRequired
};

interface FilterLabelProps {
    field: Field;
}

function FilterLabel ({ field }: FilterLabelProps): JSX.Element {
    return (
        <InputLabel
            label={field.label}
            tooltip={field.tooltip}
            isRequired={field.isRequired}
        />
    );
}

FilterLabel.propTypes = propTypes;

export default FilterLabel;